export const actions = {
  submit: 'submit',
  login: 'login',
  register: 'register',
  changeEmail: 'change_email',
  forgotPassword: 'forgot_password',
  vote: 'vote',
  newsletter: 'newsletter',
  raffle: 'raffle',
  contactForm: 'contact_form',
};
